var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickbookEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2V14H12H14C16.2875 14 18 11.8962 18 9.5C18 7.10382 16.2875 5 14 5V7C15.0265 7 16 8.03018 16 9.5C16 10.9698 15.0265 12 14 12H12V2H10ZM4 4C1.71254 4 0 6.10382 0 8.5C0 10.8962 1.71254 13 4 13V11C2.97346 11 2 9.96982 2 8.5C2 7.03018 2.97346 6 4 6H6V16H8V4H7H6H4Z",
    fill: "#0071E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickbookEnabled);
export default __webpack_public_path__ + "static/media/quickbook-enabled.20b2a713e3843d640dcc4aec67c97757.svg";
export { ForwardRef as ReactComponent };